// extracted by mini-css-extract-plugin
module.exports = {"div":"Markdown_div__35E1B"};